import ProductGroupingPartialsImage from "./ProductGroupingPartialsImage.component";

export default ProductGroupingPartialsImage;
